"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
function formatDate(dateString) {
    var _a;
    var date = new Date(dateString);
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    var lang = (_a = document.documentElement.getAttribute('lang')) !== null && _a !== void 0 ? _a : undefined;
    return date.toLocaleDateString(lang, options);
}
function GetHandbooks() {
    var _a = (0, react_1.useState)([]), handbooks = _a[0], setHandbooks = _a[1];
    var _b = (0, react_1.useState)(true), isLoading = _b[0], setIsLoading = _b[1];
    (0, react_1.useEffect)(function () {
        axios_1.default.get("/api/v2/students/minister")
            .then(function (response) {
            var _a, _b;
            setHandbooks((_b = (_a = response.data.minister) === null || _a === void 0 ? void 0 : _a.resources) !== null && _b !== void 0 ? _b : []);
            setIsLoading(false);
        })
            .catch(function (error) {
            console.log(error);
            setIsLoading(false);
        });
    }, []);
    if (isLoading)
        return react_1.default.createElement("div", null, "Loading...");
    if (handbooks.length === 0)
        return react_1.default.createElement("div", null, (0, Lang_js_1.__)('No Handbooks Available'));
    return (react_1.default.createElement("div", { className: "container student-container" },
        react_1.default.createElement("div", { className: "article-grid" }, handbooks.map(function (handbook) { return (react_1.default.createElement("div", { key: handbook.id, className: "article-grid-key" },
            react_1.default.createElement("img", { src: handbook.image_url, alt: handbook.title, className: "handbook-image" }),
            react_1.default.createElement(Link_1.default, { href: handbook.file_url, underline: "hover" },
                react_1.default.createElement(Typography_1.default, { variant: "h6" }, handbook.title)),
            react_1.default.createElement(Typography_1.default, { variant: "body2" }, handbook.description))); }))));
}
exports.default = GetHandbooks;
var handbooksContainer = document.getElementById('handbooks');
if (handbooksContainer) {
    (0, mountIsland_1.mountIsland)(handbooksContainer, react_1.default.createElement(GetHandbooks, null));
}
